// extracted by mini-css-extract-plugin
export default {"addOnList":"AddOn_addOnList__Vaadi"};